import { DEFAULT_PERMISSIONS } from '@/constants/constants';
import { UserType } from '@/Interface/userType';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PermissionsService } from '@services/permissions.service';
import { UtilityService } from '@services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { of, Subject, throwError } from 'rxjs';
import { catchError, debounceTime } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-type',
  templateUrl: './user-type.component.html',
  styleUrls: ['./user-type.component.scss']
})
export class UserTypeComponent implements OnInit {
  public userTypeForm: FormGroup;
  public ruleForm: FormGroup;
  public pageSizeControl = new FormControl(10);
  pageSize: number;
  pageToGo: number = 1;
  searchElement = '';
  serialNumberArray: Array<number> = [];
  next_page: number;
  current_page: number;
  previous_page: number;
  total_pages: number;
  total_items: number;
  private latestQueryParams: any = {};
  sortColumn: string = null;
  sortOrder: 'asc' | 'desc' = null;
  searchSubject: Subject<string> = new Subject();
  loader: boolean = false;
  // Separate from `loader`: this one is scoped to the table, so a filter,
  // a search keystroke or a page change no longer blanks the whole page.
  tableLoader: boolean = false;
  isEditMode: boolean = false;
  isViewMode: boolean = false;

  public pageRecordOptions = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
    { value: '200', label: '200' },
  ];

  public userTypeList: UserType[] = [];
  public typeDropdownList: UserType[] = [];
  public filteredSubordinateList: UserType[] = [];
  public existingRules: any = [];
  public selectedId: number;
  public selectedParentType: number = null;
  permissions = { ...DEFAULT_PERMISSIONS };
  permissionsReady: boolean = false;

  constructor(
    private modalService: NgbModal,
    private _utilityService: UtilityService,
    private toaster: ToastrService,
    private formBuilder: FormBuilder,
    private permService: PermissionsService,
  ) {
    this.initializeRuleForm();
  }

  ngOnInit(): void {
    this.initComponent()
    // this.initializeForm();
    // this.initializeRuleForm();
    // this.getTableData();
    // this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
    //   this.searchElement = searchTerm;
    //   this.updateQueryParams({ search: this.searchElement });
    // });
  }
  async initComponent() {
    this.loader = true
    await this.getComponentPermissions();

    // this.initializeForm();
    // this.initializeRuleForm();
    this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
      this.searchElement = searchTerm;
      this.updateQueryParams({ search: this.searchElement });
    });
    if (this.permissions.canView) {
      this.getTableData();
    }
    setTimeout(() => {
        this.loader = false;
    }, 250);
  }
  async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }
  // async getComponentPermissions() {
  //   const url = this.permService.getCurrentUrl();
  //   const menuFromLocal = this.permService.loadMenuFromLocalStorage();
  //   const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

  //   this.permissions = matchedMenu
  //     ? {
  //       canAdd: !!matchedMenu.canAdd,
  //       canEdit: !!matchedMenu.canEdit,
  //       canView: !!matchedMenu.canView,
  //       canDelete: !!matchedMenu.canDelete
  //     }
  //     : { ...DEFAULT_PERMISSIONS };

  //   this.permissionsReady = true;
  // }
  get hasAnyActionPermission(): boolean {
    return (
      this.permissionsReady &&
      (this.permissions.canView ||
        this.permissions.canEdit ||
        this.permissions.canDelete)
    );
  }


  initializeForm(): void {
    this.userTypeForm = this.formBuilder.group({
      id: [null],
      name: ['', [Validators.required, Validators.minLength(2)]],
      is_active: [true, [Validators.required]]
    });
  }

  initializeRuleForm(): void {
    this.ruleForm = this.formBuilder.group({
      parentUserType: [null, [Validators.required]],
      subordinateUserTypes: [[], [Validators.required, this.minLengthArray(1)]]
    });

    // Listen to parent type changes
    this.ruleForm.get('parentUserType').valueChanges.subscribe((parentId) => {
      this.onParentTypeChange(parentId);
    });
  }

  minLengthArray(min: number) {
    return (control: FormControl) => {
      if (control.value && control.value.length >= min) {
        return null;
      }
      return { minLengthArray: { valid: false } };
    };
  }

  onParentTypeChange(parentId: number): void {
    this.selectedParentType = parentId;

    // Reset subordinate selection
    this.ruleForm.patchValue({ subordinateUserTypes: [] }, { emitEvent: false });

    // Filter subordinate list
    this.filterSubordinateList(parentId);
  }
  filterSubordinateList(parentId: number): void {
    if (!parentId) {
      this.filteredSubordinateList = [];
      return;
    }

    // Debug: Check if typeDropdownList has data
    console.log('typeDropdownList:', this.typeDropdownList);
    console.log('parentId:', parentId);
    console.log('existingRules:', this.existingRules);

    // Get already assigned subordinates for this parent from existing rules
    const assignedSubordinates = this.existingRules
      .filter(rule => rule.creator_type === parentId)
      .map(rule => rule.can_create_type);

    console.log('assignedSubordinates:', assignedSubordinates);

    // Filter out the parent itself, already assigned subordinates, and Admin
    this.filteredSubordinateList = this.typeDropdownList.filter(
      type => type.id !== parentId &&
        !assignedSubordinates.includes(type.id) &&
        type.name !== 'Admin'  // Exclude Admin by name
    );

    console.log('filteredSubordinateList:', this.filteredSubordinateList);
  }
  // filterSubordinateList(parentId: number): void {
  //   if (!parentId) {
  //     this.filteredSubordinateList = [];
  //     return;
  //   }

  //   // Get already assigned subordinates for this parent from existing rules
  //   const assignedSubordinates = this.existingRules
  //     .filter(rule => rule.creator_type === parentId)
  //     .map(rule => rule.can_create_type);

  //   // Filter out the parent itself and already assigned subordinates
  //   this.filteredSubordinateList = this.typeDropdownList.filter(
  //     type => type.id !== parentId && !assignedSubordinates.includes(type.id)
  //   );
  // }

  resetForm(): void {
    this.userTypeForm.reset({
      id: null,
      name: '',
      is_active: true
    });
    this.isEditMode = false;
    this.isViewMode = false;
  }

  resetRuleForm(): void {
    this.ruleForm.reset({
      parentUserType: null,
      subordinateUserTypes: []
    });
    this.selectedParentType = null;
    this.filteredSubordinateList = [];
  }

  openHierarchyPopup(content: any): void {
    this.fetchUserTypeDropdown();
    this.fetchUserCreationHierarchy();
    this.resetRuleForm();
    this.modalService.open(content, { centered: true, size: 'lg', scrollable: true });
  }

  deleteRule(ruleId: number): void {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this hierarchy rule?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FB8C04',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        // Find the rule to be deleted
        const ruleToDelete = this.existingRules.find(rule => rule.id === ruleId);

        // Remove from existing rules
        this.existingRules = this.existingRules.filter(rule => rule.id !== ruleId);

        // TODO: Delete from backend
        this._utilityService.deleteHierarchyRule(ruleId).subscribe(() => {
          this.toaster.success('Rule deleted successfully');
        });

        this.toaster.success('Rule deleted successfully');

        // Re-filter subordinate list if the current parent matches the deleted rule's parent
        if (this.selectedParentType === ruleToDelete?.creator_type) {
          this.filterSubordinateList(this.selectedParentType);
        }
      }
    });
  }

  onSubmitRule(): void {
    // Mark all fields as touched to show validation errors
    Object.keys(this.ruleForm.controls).forEach(key => {
      this.ruleForm.get(key).markAsTouched();
    });

    if (this.ruleForm.valid) {
      const parentType = this.ruleForm.value.parentUserType;
      const subordinateTypes = this.ruleForm.value.subordinateUserTypes;

      // Create rules array
      const rules = subordinateTypes.map(subordinateId => ({
        creator_type: parentType,
        can_create_type: subordinateId
      }));

      const payload = { rules };

      // console.log('Hierarchy Rules Payload:', payload);

      // TODO: Send to backend
      this._utilityService.createHierarchyRules(payload).subscribe(
        (response) => {
          this.toaster.success('Rules created successfully');
          this.fetchUserCreationHierarchy();
          this.resetRuleForm();
        },
        (error) => {
          // this.toaster.error('Failed to create rules');
          this.handleApiFieldErrors(error, this.toaster);
          return of(undefined);
        }
      );

      // // For now, simulate adding to existing rules
      // rules.forEach((rule, index) => {
      //   const parentName = this.typeDropdownList.find(t => t.id === rule.creator_type)?.name;
      //   const subordinateName = this.typeDropdownList.find(t => t.id === rule.can_create_type)?.name;

      //   this.existingRules.push({
      //     id: Date.now() + index, // Temporary ID
      //     creator_type: rule.creator_type,
      //     can_create_type: rule.can_create_type,
      //     message: `${parentName} can create ${subordinateName}`
      //   });
      // });

      // this.toaster.success('Rules added successfully');
      // this.resetRuleForm();
    }
  }

  openAddPopUp(content: any): void {
    this.isEditMode = false;
    this.isViewMode = false;
    this.resetForm();
    this.modalService.open(content, { centered: true, scrollable: true });
  }

  openEditPopUp(item: UserType, content: any): void {
    this.isEditMode = true;
    this.isViewMode = false;
    this.selectedId = item.id;
    this.userTypeForm.patchValue({
      id: item.id,
      name: item.name,
      is_active: item.is_active
    });
    this.modalService.open(content, { centered: true, scrollable: true });
  }

  openViewPopUp(item: UserType, content: any): void {
    this.isEditMode = false;
    this.isViewMode = true;
    this.selectedId = item.id;
    this.userTypeForm.patchValue({
      id: item.id,
      name: item.name,
      is_active: item.is_active
    });
    this.userTypeForm.disable();
    this.modalService.open(content, { centered: true, scrollable: true }).result.then(
      () => {
        this.userTypeForm.enable();
        this.resetForm();
      },
      () => {
        this.userTypeForm.enable();
        this.resetForm();
      }
    );
  }

  onSubmit(): void {
    if (this.userTypeForm.valid) {
      if (this.isEditMode) {
        this.updateUserType();
      } else {
        this.saveUserType();
      }
    } else {
      Object.keys(this.userTypeForm.controls).forEach(key => {
        this.userTypeForm.get(key).markAsTouched();
      });
    }
  }

  saveUserType(): void {
    const payload = {
      name: this.userTypeForm.value.name.trim(),
      is_active: this.userTypeForm.value.is_active
    };

    this._utilityService.addUserType(payload).pipe(
      catchError(error => {
        if (error.status === 400) {
          this.toaster.error(error.error.message);
        } else {
          this.toaster.error('An error occurred. Please try again later.');
        }
        return throwError(() => error);
      })
    ).subscribe(response => {
      if (response && response.message) {
        this.getTableData();
        this.modalService.dismissAll();
        this.resetForm();
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.message,
          showConfirmButton: false,
          timer: 1500
        });
      }
    });
  }

  updateUserType(): void {
    Swal.fire({
      title: 'Are you sure you want to update this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FB8C04',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Update it!'
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          id: this.userTypeForm.value.id,
          name: this.userTypeForm.value.name.trim(),
          is_active: this.userTypeForm.value.is_active
        };

        this._utilityService.editUserType(payload).pipe(
          catchError(error => {
            if (error.status === 400) {
              this.toaster.error(error.error.message);
            } else {
              this.toaster.error('An error occurred. Please try again later.');
            }
            return throwError(() => error);
          })
        ).subscribe(response => {
          if (response && response.message) {
            this.getTableData();
            this.modalService.dismissAll();
            this.resetForm();
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          }
        });
      }
    });
  }

  toggleUserTypeStatus(item: UserType): void {
    const newStatus = !item.is_active;
    const payload = {
      id: item.id,
      name: item.name,
      is_active: newStatus
    };

    this._utilityService.editUserType(payload).pipe(
      catchError(error => {
        this.toaster.error('Failed to update status');
        return throwError(() => error);
      })
    ).subscribe(response => {
      if (response && response.message) {
        this.getTableData();
        this.toaster.success(response.message);
      }
    });
  }

  private updateQueryParams(paramsToUpdate: any): void {
    this.latestQueryParams = {
      ...this.latestQueryParams,
      ...paramsToUpdate
    };

    if (this.latestQueryParams.search === '') {
      this.latestQueryParams.search = null;
    }
    if (this.latestQueryParams.page === 1) {
      this.latestQueryParams.page = null;
    }
    if (this.latestQueryParams.size === 10) {
      this.latestQueryParams.size = null;
    }
    if (this.latestQueryParams.sort === null) {
      delete this.latestQueryParams.sort;
    }
    if (this.latestQueryParams.column === null) {
      delete this.latestQueryParams.column;
    }

    if (this.latestQueryParams.page === 1 || (this.latestQueryParams.page && (this.latestQueryParams.search))) {
      if (this.latestQueryParams.page > 1) {
        this.latestQueryParams.page = paramsToUpdate.page;
        if (this.latestQueryParams.size > 10) {
          this.latestQueryParams.size = paramsToUpdate.size;
        }
      } else {
        this.latestQueryParams.page = null;
      }
    }

    if (!this.next_page && (paramsToUpdate.size || paramsToUpdate.search)) {
      this.latestQueryParams = {
        size: paramsToUpdate.size || null,
        search: paramsToUpdate.search || null
      };
    }
    this.getTableData();
  }

  private getTableData(): void {
    const name = this.latestQueryParams['search'] || this.searchElement;
    const page = this.latestQueryParams['page'] ? +this.latestQueryParams['page'] : 1;
    const size = this.latestQueryParams['size'] ? +this.latestQueryParams['size'] : 10;
    const sort = this.latestQueryParams['sort'] || null;
    const column = this.latestQueryParams['column'] || null;
    this.getUserTypeList(name, page, size, sort, column);
  }

  getUserTypeList(name: string, page: number, size: number, sort: string | null, column: string | null): void {
    this.tableLoader = true;
    this.userTypeList = [];
    this.serialNumberArray = [];
    this._utilityService
      .getUserTypesList(name, page, size, sort, column)
      .subscribe((res: any) => {
        if (res && res['pagination']) {
          this.userTypeList = res.results.map((item: any, index: number) => ({
            ...item,
            srNo: (res.pagination.current_page - 1) * size + index + 1
          }));

          this.current_page = res.pagination.current_page;
          this.next_page = res.pagination.next_page;
          this.previous_page = res.pagination.previous_page;
          this.total_pages = res.pagination.total_pages;
          this.total_items = res.pagination.total_records;
          this.enablePagination();
        }
        this.tableLoader = false;
      }, (error) => {
        this.tableLoader = false;
        this.toaster.error('Failed to load data');
      });
  }

  public searchData(event: Event): void {
    this.searchElement = (event.target as HTMLInputElement)?.value || '';
    this.searchSubject.next(this.searchElement);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.total_pages) {
      this.updateQueryParams({ page: page });
    }
  }

  navigatePage(direction: string): void {
    if (direction === 'prev' && this.current_page > 1) {
      this.goToPage(this.current_page - 1);
    } else if (direction === 'next' && this.next_page !== null) {
      this.goToPage(this.current_page + 1);
    }
  }

  navigateToPage(): void {
    if (this.pageToGo >= 1 && this.pageToGo <= this.total_pages) {
      this.goToPage(this.pageToGo);
    }
  }

  public changePageSize(): void {
    this.pageSize = this.pageSizeControl.value!;
    this.updateQueryParams({ size: this.pageSize });
  }

  enablePagination(): void {
    const linkElement = document.getElementById('prevPage');
    if (linkElement) {
      if (this.previous_page === null) {
        linkElement.setAttribute('disabled', 'true');
        linkElement.style.pointerEvents = 'none';
        linkElement.style.color = 'gray';
      } else {
        linkElement.removeAttribute('disabled');
        linkElement.style.pointerEvents = 'auto';
        linkElement.style.color = '';
      }
    }
  }

  fetchUserTypeDropdown(): void {
    this._utilityService.getUserTypesDropdown().subscribe((res) => {
      if (res) {
        this.typeDropdownList = res;
      }
    });
  }

  fetchUserCreationHierarchy(): void {
    this._utilityService.getUserCreationHierarchyRules().subscribe((res) => {
      if (res) {
        this.existingRules = res;
      }
    });
  }
  handleApiFieldErrors(error: HttpErrorResponse, toastr: ToastrService): void {

    // Case 1: status is an array
    if (error.error?.status && Array.isArray(error.error.status)) {
      error.error.status.forEach((msg: string) => toastr.error(msg));
      return;
    }

    // Case 2: single message
    if (error.error?.message) {
      toastr.error(error.error.message);
      return;
    }

    // Case 3: field validation errors
    if (error.error?.errors) {
      Object.keys(error.error.errors).forEach(key => {
        const message = Array.isArray(error.error.errors[key])
          ? error.error.errors[key][0]
          : error.error.errors[key];
        toastr.error(message);
      });
      return;
    }

    // Case 4: rules array with non_field_errors
    if (Array.isArray(error.error?.rules)) {
      error.error.rules.forEach((rule: any) => {
        if (Array.isArray(rule?.non_field_errors)) {
          rule.non_field_errors.forEach((msg: string) => {
            toastr.error(msg);
          });
        }
      });
      return;
    }

    // Fallback
    toastr.error('Sorry, something went wrong. Please try again.');
  }

}